<template>
  <div class="organization-page">
    <NavbarSecondaryAccount />
    <div class="top-line--flex">
      <h1>Organization Info</h1>
    </div>

    <div class="paper-block-container mt-2">
      <Organization />
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/mixins/page-title';
  import NavbarSecondaryAccount from '@/components/blocks/layouts/NavbarSecondaryAccount';
  import Organization from '@/components/blocks/reactComponents/Organization';

  export default {
    name: 'OrganizationPage',

    components: {
      NavbarSecondaryAccount,
      Organization,
    },

    mixins: [PageTitle],

    data() {
      return {
        pageTitle: 'HPLC Cloud: Organization',
      };
    },
  };
</script>
